
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";
import filters from "@/filters";
import toast from "@/functions/toast.function";
import { NewsModel } from "@/models/information.model";

@Component({
  components: {},
  filters
})
export default class ModalConfirmDelete extends Vue {
  /* VUEX */

  // ACTION
  @Action("actionDeleteNews", { namespace: "information" })
  private actionDeleteNews: any;

  // PROP
  @Prop({ default: false })
  private isShow: boolean;

  // STATE
  @State("news", { namespace: "information" })
  private news: NewsModel;

  /* INITIALIZATION */

  private showUploadLogo: boolean = false;
  private showUploadBanner: boolean = false;
  private bannerName: string = "";

  constructor() {
    super();
  }

  /* WATCH */

  /* LIFECYCLE */

  /* METHODS */

  private clickYes() {
    this.actionDeleteNews({
      id: this.news.id,
      listener: () => {
        this.$emit("callback");
      }
    });
  }

  private clickNo() {
    this.$emit("update:isShow", false);
  }
}
